import React from "react"

import Dialog from "components/common/dialog/dialog"

interface IHrConfirmDialog {
  open: boolean
  onClose: () => void
  onActionButtonClick: () => void
  titleText: string
  actionAcceptText: string
}

const HrConfirmDialog: React.FC<IHrConfirmDialog> = ({
  open,
  onClose,
  onActionButtonClick,
  titleText,
  actionAcceptText,
}) => {
  return (
    <Dialog
      open={open}
      actionAcceptText={actionAcceptText}
      titleText={titleText}
      onClose={onClose}
      desktopMaxWidth="534px"
      tabletMaxWidth="344px"
      onActionButtonClick={onActionButtonClick}
    />
  )
}

export default HrConfirmDialog
